import { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQS = [
  {
    q: "What areas of Ottawa does Capital Shield service?",
    a: "We service homes and small commercial properties across Ottawa and the surrounding regions — including Kanata, Barrhaven, Orleans, Nepean, Gloucester, Stittsville, Westboro, the Glebe and Centretown.",
  },
  {
    q: "When do you dispatch for snow removal in Ottawa?",
    a: "We're a 24/7 storm-response operation. Our crews are dispatched on every trigger snowfall (typically 2.5 cm / 1 inch of accumulation) so your driveway, walkway and steps are cleared before the morning commute.",
  },
  {
    q: "How much does driveway sealing cost in Ottawa?",
    a: "Sealcoating pricing depends on driveway square footage, current condition, and whether crack-fill prep is required. Most residential Ottawa driveways fall between $150 and $450. Request a free on-site quote for exact pricing.",
  },
  {
    q: "Is Capital Shield insured?",
    a: "Yes. Capital Shield is fully insured with liability coverage and WSIB compliance, so you and your property are protected on every visit.",
  },
  {
    q: "Do you offer seasonal snow removal contracts?",
    a: "Yes — we offer flat-rate seasonal snow removal contracts as well as per-storm pricing. Seasonal contracts include salting on demand and are usually the best value for Ottawa winters.",
  },
  {
    q: "When is the best time to sealcoat a driveway in Ottawa?",
    a: "Late spring through early fall (May to September) is ideal, when daytime temperatures stay above 10°C and there's no rain in the 24-hour forecast. Sealing every 2–3 years protects Ottawa asphalt against freeze-thaw damage.",
  },
];

export default function Faq() {
  const [open, setOpen] = useState(0);

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section
      id="faq"
      data-testid="faq-section"
      aria-label="Frequently asked questions about Capital Shield"
      className="relative py-24 md:py-32 bg-[#070F1C]"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="mb-14 text-center">
          <div className="hairline mb-6">Common Questions</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
            Everything you need to know,
            <span className="text-[#C9A24B]"> before you call.</span>
          </h2>
        </div>

        <div className="border border-white/10 divide-y divide-white/10">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} data-testid={`faq-item-${i}`} className="bg-[#0B1B3D]">
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  data-testid={`faq-toggle-${i}`}
                  className="w-full text-left flex items-center justify-between gap-6 p-6 md:p-7 hover:bg-[#0F2554]/60 transition-colors"
                >
                  <h3 className="font-display text-lg md:text-xl font-semibold text-white pr-4">
                    {f.q}
                  </h3>
                  <span className="flex-shrink-0 text-[#C9A24B]">
                    {isOpen ? <Minus size={18} /> : <Plus size={18} />}
                  </span>
                </button>
                {isOpen && (
                  <div className="px-6 md:px-7 pb-7 pt-0 text-sm md:text-base text-white/75 leading-relaxed">
                    {f.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
    </section>
  );
}
